import React from "react";
import { Link } from "react-router-dom";
// import { FaAngleUp } from 'react-icons/fa';
// import LiveChat from "../components/LiveChat";

const Footer = () => {
  return (
    <div>
      <footer className="text-gray-400 bg-gray-900 body-font">
        <div className="container px-5 py-12 mx-auto">
          <div className="flex flex-wrap md:text-left text-center order-first">
            <div className="lg:w-1/4 md:w-1/2 w-full px-4">
              <h2 className="title-font font-medium text-white tracking-widest text-md mb-3">
                Projects
              </h2>
              <nav className="list-none mb-10">
                <li>
                  <a
                    href="https://maruf-sarker.netlify.app/"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Portfolio Website
                  </a>
                </li>
                <li>
                  <a
                    href="https://mms-facebook-clone.netlify.app/"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Facebook Clone
                  </a>
                </li>
                <li>
                  <a
                    href="https://mms-note-taking-app.netlify.app/"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Note Taking App
                  </a>
                </li>
                <li>
                  <a
                    href="https://strangers-bd.netlify.app/"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Strangers CP Team
                  </a>
                </li>
              </nav>
            </div>
            <div className="lg:w-1/4 md:w-1/2 w-full px-4">
              <h2 className="title-font font-medium text-white tracking-widest text-md mb-3">
                YouTube
              </h2>
              <nav className="list-none mb-10">
                <li>
                  <a
                    href="https://youtube.com/playlist?list=PLCWi-JUKQh2-AD0926fony-zNLpYC8ww3"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Beecrowd Problem Solving
                  </a>
                </li>
                <li>
                  <a
                    href="https://youtube.com/playlist?list=PLCWi-JUKQh2__07PlXyz-zPYbhxb983d4"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Golang Problem Solving
                  </a>
                </li>
                <li>
                  <a
                    href="https://youtube.com/playlist?list=PLCWi-JUKQh2-YQ6U_dqQix3s00tIkgeKJ"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Command Line for Beginners
                  </a>
                </li>
                <li>
                  <a
                    href="https://youtube.com/playlist?list=PLCWi-JUKQh2_RkqFDtpqFvFFRuU-3RtgI"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    HTML CSS Projects
                  </a>
                </li>
              </nav>
            </div>
            <div className="lg:w-1/4 md:w-1/2 w-full px-4">
              <h2 className="title-font font-medium text-white tracking-widest text-md mb-3">
                Social Accounts
              </h2>
              <nav className="list-none mb-10">
                <li>
                  <a
                    href="https://www.facebook.com/mdmarufsarkerr"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Facebook
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/mdmarufsarker"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/mdmarufsarker/"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Linkedin
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/md_marufsarker"
                    className="text-gray-400 hover:text-white"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Twitter
                  </a>
                </li>
              </nav>
            </div>
            <div className="lg:w-1/4 md:w-1/2 w-full px-4">
              <h2 className="title-font font-medium text-white tracking-widest text-sm mb-3">
                SUBSCRIBE
              </h2>
              <div className="flex xl:flex-nowrap md:flex-nowrap lg:flex-wrap flex-wrap justify-center items-end md:justify-start">
                <div className="relative w-40 sm:w-auto xl:mr-4 lg:mr-0 sm:mr-4 mr-2">
                  <label
                    htmlFor="footer-field"
                    className="leading-7 text-sm text-gray-400"
                  >
                    Enter your email
                  </label>
                  <input
                    type="text"
                    id="footer-field"
                    name="footer-field"
                    className="w-full bg-gray-800 rounded border bg-opacity-40 border-gray-700 focus:bg-transparent focus:ring-2 focus:ring-indigo-900 focus:border-indigo-500 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  />
                </div>
                <button className="lg:mt-2 xl:mt-0 flex-shrink-0 inline-flex text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded">
                  Subscribe
                </button>
              </div>
              <p className="text-gray-500 text-sm mt-2 md:text-left text-center">
                Subscribe my newsletter
                <br className="lg:block hidden" />
                to get more information
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-800 bg-opacity-75">
          <div className="container px-5 py-6 mx-auto flex items-center sm:flex-row flex-col">
            <div className="flex title-font font-medium items-center md:justify-start justify-center text-white">
              <Link to="/" className="ml-3 font-sacramento text-3xl font-bold">
                Maruf Sarker
              </Link>
            </div>
            <p className="text-sm text-gray-400 sm:ml-6 sm:mt-0 mt-4 flex">
              © 2022 Maruf Sarker —
              <a
                className="copyrighted-badge ml-1"
                rel="noopener noreferrer"
                title="Copyrighted.com Registered &amp; Protected"
                target="_blank"
                href="https://www.copyrighted.com/website/QDPMClcEffb10n4v"
              >
                <img
                  alt="Copyrighted.com Registered &amp; Protected"
                  border="0"
                  width="125"
                  height="25"
                  srcSet="https://static.copyrighted.com/badges/125x25/03_2_2x.png 2x"
                  src="https://static.copyrighted.com/badges/125x25/03_2.png"
                />
              </a>
              <script src="https://static.copyrighted.com/badges/helper.js"></script>
            </p>
            <span className="inline-flex sm:ml-auto sm:mt-0 mt-4 mr-2 justify-center sm:justify-start">
              <a
                href="https://www.facebook.com/mdmarufsarkerr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400"
              >
                <svg
                  fill="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                >
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/md_maruf_sarker/"
                className="ml-3 text-gray-400"
              >
                <svg
                  fill="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                >
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
                </svg>
              </a>
              <a
                href="https://twitter.com/md_marufsarker"
                className="ml-3 text-gray-400"
              >
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                >
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/in/mdmarufsarker/"
                className="ml-3 text-gray-400"
              >
                <svg
                  fill="currentColor"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="0"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="none"
                    d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
                  ></path>
                  <circle cx="4" cy="4" r="2" stroke="none"></circle>
                </svg>
              </a>
            </span>
            {/* <LiveChat /> */}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
